<template>
  <div class="search-page">
    <div class="container">
      <h2>Search Results for "{{ searchQuery }}"</h2>
      <div v-if="searchResults.length > 0">
        <ul>
          <li v-for="result in searchResults" :key="result.id">
            <router-link
              :to="{
                name: 'Article',
                params: {
                  section: result.section,
                  id: result.id.replace(`${result.section}-`, ''), // Remove section prefix from ID
                },
              }"
            >
              {{ result.title }}
            </router-link>
            <p>{{ result.summary }}</p>
          </li>
        </ul>
      </div>
      <div v-else>
        <p>No results found for "{{ searchQuery }}".</p>
      </div>
    </div>
  </div>
</template>

<script>
import { idx, allDocuments } from '@/data/searchIndex.js';

export default {
  name: 'Search',
  data() {
    return {
      searchQuery: this.$route.query.q || '',
      searchResults: [],
    };
  },
  watch: {
    '$route.query.q'(newQuery) {
      this.searchQuery = newQuery;
      this.performSearch();
    },
  },
  created() {
    this.performSearch();
  },
  methods: {
    performSearch() {
      if (this.searchQuery.trim() !== '') {
        console.log('Performing search for:', this.searchQuery);

        // Perform the search using Lunr.js
        const results = idx.search(this.searchQuery);

        console.log('Raw search results:', results);

        // Map the search results to the actual documents
        this.searchResults = results.map((result) => {
          const doc = allDocuments.find((d) => d.id === result.ref);
          return doc;
        });

        console.log('Final search results:', this.searchResults);
      } else {
        this.searchResults = [];
      }
    },
  },
};
</script>

<style scoped>
/* Add styles for the search page */
.search-page {
  padding: 40px 0;
}

.search-page h2 {
  margin-bottom: 20px;
}

.search-page ul {
  list-style-type: none;
  padding: 0;
}

.search-page li {
  margin-bottom: 20px;
}

.search-page li p {
  margin: 5px 0 0;
}
</style>